@import '~ss-ui-client/src/constants/spacing.module.less';

.page {
  padding: @space-24;
  max-width: 875px;
}

.tabs {
  height: 100%;
}

.tab-list {
  border-bottom: 1px solid var(--grey-300);
  margin-bottom: @space-24;
}

.tab-panel {
  border-top: none;
}
